import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/globals.css";

import * as Sentry from "@sentry/react";

if (process.env.PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.PUBLIC_SENTRY_DSN,
    environment: process.env.PUBLIC_SENTRY_ENVIRONMENT,
    tracesSampleRate: 0.4,
    debug: false,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
